module.exports = __webpack_public_path__ + "static/media/democrat.1a57d32f.svg";